import { render, staticRenderFns } from "./VehicleDefaultSelector.vue?vue&type=template&id=64ad17f2"
import script from "./VehicleDefaultSelector.vue?vue&type=script&lang=js"
export * from "./VehicleDefaultSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports